<template>
  <div>
    <div id="header-info">
      <div class="topbar">
        <topbar />
      </div>
      <div>
        <search @search="search" />
      </div>
    </div>
    <div>
      <cart-side />
    </div>
    <div>
      <app-nav />
    </div>
    <div class="promotional-msg">
      <div class="province-msg">
        <img src="../../../static/images/promotional_bg.png" alt="">
        <h1>会员促销</h1>
        <div ref="province" class="province-data">
          <div v-if="provinceInfos" ref="dataTag" class="data">
            <p v-for="(item,index) in provinceInfos" :key="index">({{ index+1 }}){{ item }}</p>
          </div>
        </div>
      </div>
      <div class="other-msg">
        <h1>产品促销</h1>
        <div ref="other" class="province-data">
          <div v-if="otherInfos" class="data">
            <p v-for="(item,index) in otherInfos" :key="index">({{ index+1 }}){{ item }}</p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <app-footer />
    </div>
  </div>
</template>
<script>
import footer from '@/components/Footer.vue'
import topbar from '@/components/TopBar.vue'
import search from '@/components/Search.vue'
import nav from '@/components/Nav.vue'
import CartSide from './CartSide'
import { InfoService } from '@/service/InfoService'
export default {
  components: {
    'cart-side': CartSide, 'app-nav': nav,
    search, topbar, 'app-footer': footer
  },
  data () {
    return {
      otherInfos: [],
      provinceInfos: []
    }
  },
  created () {
    this.loadProvinceInfos(100)
    this.loadOtherInfos(100)
  },
  mounted () {
    this.scroll()
  },
  destroyed () {
    this.time()
  },
  methods: {
    loadProvinceInfos (size) {
      const Infos = new InfoService(this.$axios)
      Infos.loadPromotionInfos({ index: 1, size: size, isLocal: 1 }).then(infos => {
        const { pageInfo, infoList } = infos
        if (pageInfo.count > size) {
          this.loadProvinceInfos(pageInfo.count)
        } else {
          this.provinceInfos = infoList
        }
      })
    },
    loadOtherInfos (size) {
      const Infos = new InfoService(this.$axios)
      Infos.loadPromotionInfos({ index: 1, size: size, isLocal: 2 }).then(infos => {
        const { pageInfo, infoList } = infos
        if (pageInfo.count > size) {
          this.loadOtherInfos(pageInfo.count)
        } else {
          this.otherInfos = infoList
        }
      })
    },
    search (str) {},
    scroll () {
      const H = 89
      var province = this.$refs.province
      var size = Math.floor(this.$refs.dataTag.offsetHeight / H)
      if (Math.round(province.scrollHeight / H) >= size) {
        this.time(province, H, size)
      }
      var other = this.$refs.other
      if (Math.round(other.scrollHeight / H) >= size) {
        this.time(other, H, size)
      }
    },
    time (demon, H, size) {
      var Timer = setInterval(() => {
        if (demon === undefined) {
          clearInterval(Timer)
        } else {
          demon.scrollTop += H
          console.log(demon.scrollHeight, demon.scrollTop, '1')
          if ((demon.scrollHeight - demon.scrollTop) / H < size) {
            console.log('停止')
            clearInterval(Timer)
          }
        }
      }
      , 30000)
    }
  }
}
</script>
<style>
  .promotional-msg {
    max-width: 1200px;
    margin: 0 auto;
    padding: 5px 20px 0 20px;
    display: flex;
  }
  .promotional-msg h1 {
    color: #fff;
    font-size: 1.5rem;
    padding-left: 0;
    text-align: center;
    width: 100%;
  }
  .promotional-msg .province-msg,
  .promotional-msg .other-msg {
    width: 570px;
    height: 500px;
    position:relative;
    transition: .3s all ease;
  }
  .promotional-msg .province-msg img {
    transform:rotate(180deg);
  }
  .promotional-msg .other-msg {

    background: url('../../../static/images/promotional_bg.png');
  }
  .promotional-msg .province-msg {
    margin-right: 20px;
  }
  .province-msg h1 {
    position: absolute;
    top: 0;
    left: 0;
  }
  .promotional-msg .province-data {
    height: 445px;
    width: 100%;
    position:absolute;
    top: 45px;
    left: 0;
    background-color: #fff;
    overflow-y: scroll;
  }
  .province-data .data {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
  .province-data p {
    height: 60px;
    text-align: left;
    overflow: hidden;
    padding-left: 10px;
    margin-bottom: 29px;
    line-height: 20px;
  }
</style>
